import styles from './pricingplan.module.css';
import React, {useState} from 'react'
import { Button, Card, CardGroup, Col,Collapse, Container , ListGroup, ListGroupItem, Table} from 'react-bootstrap';
import { Footer } from '../Footer/Footer';
import {Header } from '../Header/Header';
import pricingillustration from '../../assets/imgs/pricingillustration.png'
import good from '../../assets/icons/good.png';
import stop from '../../assets/icons/stop.png';
import plus from '../../assets/icons/plus.png';



export const PricingPlan = () => {
  const [open, setOpen] = useState(false);
  return (
    <div>
        <Header/>
        <Container fluid style={{background:'#f0f4f8'}}>
        <Container>
            <Col>
            <div>
                <h3 className={`${styles.heading}`}></h3>
                <h3 className={`${styles.heading}`}>Pricing Details</h3>
                <p className={`${styles.desc}`}>Now, your business can go Online without 
                spending more than your Budget</p>
            </div>
            <div>
                <img src={pricingillustration} alt='pricing illustration' className={`img-fluid ${styles.illustration}`}/>
            </div>
            </Col>
            </Container>
        </Container>
        <Container>
        <Col>
            <CardGroup className={`gap-2 ms-lg-auto ${styles.cardgroup}`} style={{ marginTop: '74px'}}>
                <Card className={`me-lg-1 ${styles.card}`}>
                    <Card.Body>
                    <Card.Title className={`${styles.cardTitle}`}>Small Business</Card.Title>
                    <Card.Subtitle className={`${styles.cardsubtitle}`}>Website</Card.Subtitle>
                    <h1 className={`${styles.amount}`}>N10,000</h1>
                    <h2 className={`${styles.small}`}>Per page</h2>
                    <p className={`${styles.small2}`}>Minimum of 3 pages </p>
                    </Card.Body>
                </Card>

                <Card className={`me-lg-1 ${styles.card}`}>
                    <Card.Body>
                    <Card.Title className={`${styles.cardTitle}`}>Small Business</Card.Title>
                    <Card.Subtitle className={`${styles.cardsubtitle}`}>Mobile Application</Card.Subtitle>
                    <h1 className={`${styles.amount}`}>N15,000</h1>
                    <h2 className={`${styles.small}`}>Per functionality</h2>
                    <p className={`${styles.small2}`}>Minimum of 20 Functionalities </p>
                    </Card.Body>
                </Card>

                <Card className={`me-lg-1 ${styles.card}`}>
                    <Card.Body>
                    <Card.Title className={` text-white ${styles.cardTitledangr}`}>ENTERPRISE</Card.Title>
                    <Card.Subtitle className={`${styles.cardsubtitle}`}>Custom Website</Card.Subtitle>
                    <h1 className={`${styles.amount}`}>N50,000</h1>
                    <h2 className={`${styles.small}`}>Per page</h2>
                    <p className={`${styles.small2}`}>Minimum of 10 pages </p>
                    </Card.Body>
                </Card>

                <Card className={`${styles.card}`}>
                    <Card.Body>
                    <Card.Title className={`text-white ${styles.cardTitledangr}`}>ENTERPRISE</Card.Title>
                    <Card.Subtitle className={`${styles.cardsubtitle}`}>Custom Website</Card.Subtitle>
                    <h1 className={`${styles.amount}`}>N75,000</h1>
                    <h2 className={`${styles.small}`}>Per page</h2>
                    <p className={`${styles.small2}`}>Minimum of 20 Functionalities  </p>
                    </Card.Body>
                </Card>
            </CardGroup>
            </Col>
        </Container>
        {/* table  */}
        <Container>
            <Col>
            <div className={`d-fle`}>
            <ListGroup className={`${styles.group}`}>
                <ListGroup.Item className={`${styles.list}`}>Small Business</ListGroup.Item>
            </ListGroup><br/>
            <ListGroup horizontal className={` gap-3 ${styles.group1}`}>
                <ListGroup.Item className={` text-center ${styles.list1}`}>Website</ListGroup.Item>
                <ListGroup.Item className={`${styles.list2}`}>Web/Mobile App or E-commerce  </ListGroup.Item>

            </ListGroup>

            <ListGroup className={`${styles.group2}`}>
                <ListGroup.Item className={`${styles.list3}`}>Enterprises</ListGroup.Item>
            </ListGroup>
            <ListGroup horizontal className={`${styles.group2}`}>
                <ListGroup.Item className={`${styles.list22}`}>Custom Website</ListGroup.Item>
                <ListGroup.Item className={`${styles.list23}`}>Web/Mobile App or E-commerce  </ListGroup.Item>

            </ListGroup>
</div>

            <Table striped bordered hover>
  <thead>
    <tr>
      <th className={`bg-light border-0 ${styles.tabheader}`}>Feature</th>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>

    </tr>
  </thead>
  <tbody>
    <tr>
      <td className={` ${styles.tabheading}`}>Domain Name</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={`img-fluid ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>
    <tr>
      <td className={` ${styles.tabheading}`}>Hosting Plan</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={stop}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>
    <tr>
      <td className={` ${styles.tabheading}`}>Hostiing Plan</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>

    <tr>
      <td className={` ${styles.tabheading}`}>Hosting Plan</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={stop}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>

    <tr>
      <td className={` ${styles.tabheading}`}>Hosting Plan</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>
  </tbody>
</Table>   
          <Button variant='link' onClick={() => setOpen(!open)}  aria-controls="collapse" aria-expanded={open} className={`${styles.btn}`}><img src={plus} alt='plus sign' /> See All Features </Button> 
          <Collapse in={open}>
            <div id="collapse" className={`${styles.collapse}`}>
            <Table striped bordered hover>
  <thead>
    <tr>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>
      <th className={`bg-light border-0 ${styles.tabheader}`}></th>

    </tr>
  </thead>
  <tbody>
    <tr>
      <td className={` ${styles.tabheading}`}>Domain Name</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>
    <tr>
      <td className={` ${styles.tabheading}`}>Hosting Plan</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={stop}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>
    <tr>
      <td className={` ${styles.tabheading}`}>Hostiing Plan</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>

    <tr>
      <td className={` ${styles.tabheading}`}>Hosting Plan</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={stop}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>

    <tr>
      <td className={` ${styles.tabheading}`}>Hosting Plan</td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
      <td className={` ${styles.tabheading}`}><img src={good}  className={` ${styles.icons}`}/></td>
    </tr>
  </tbody>
</Table> 
           </div> 
           </Collapse>          
            </Col>
        </Container>

        <Container>
            <Col>
            <h3 className={`${styles.otherplans}`}>See other plans</h3>
                <CardGroup className={`gap-3 ${styles.cardgroup2}`}>
                    <Card className={`${styles.card2}`} style={{ background: '#9B51E0'}}>
                    <Card.Title className={` ${styles.cardTitle2}`}>SITE BUILDER/BRANCH</Card.Title>
                    <h1 className={`${styles.amount2}`}>N5,000</h1>
                    <Card.Subtitle className={`${styles.cardsubtitle2}`}>minimum of 3 pages</Card.Subtitle>
                        <Card.Link className={`${styles.navlink}`}>Learn more</Card.Link>
                    </Card>

                    <Card className={`${styles.card2}`} style={{ background: '#2F80ED'}}>
                    <Card.Title className={` ${styles.cardTitle2}`}>LEAD PAGE WEBSITE</Card.Title>
                    <h1 className={`${styles.amount2}`}>N100,000</h1>
                    <Card.Subtitle className={`${styles.cardsubtitle2}`}>minimum of 1 page</Card.Subtitle>
                        <Card.Link className={`${styles.navlink}`}>Learn more</Card.Link>
                    </Card>

                    <Card className={`${styles.card2}`} style={{ background: '#56CCF2'}}>
                    <Card.Title className={` ${styles.cardTitle2}`}>ONE PAGER WEBSITE </Card.Title>
                    <h1 className={`${styles.amount2}`}>N50,000</h1>
                        <Card.Link className={` ${styles.navlink1}`}>Learn more</Card.Link>
                    </Card>

                    <Card className={`${styles.card2}`} style={{ background: '#F173C6'}}>
                    <Card.Title className={` ${styles.cardTitle2}`}>ONE PAGER E-COMMERCE
WEBSITE</Card.Title>
                    <h1 className={`${styles.amount2}`}>N100,000</h1>
                    {/* <Card.Subtitle className={`${styles.cardsubtitle2}`}>minimum of 3 pages</Card.Subtitle> */}
                        <Card.Link className={`${styles.navlink1}`}>Learn more</Card.Link>
                    </Card>
                </CardGroup>
            </Col>
        </Container>
        <Footer/>
    </div>
  )
}
